/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import React, { useState, useEffect } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid';

import { useMutation } from '@tanstack/react-query';
import PageBanner from '../../components/utils/PageBanner';
import GraphqlService from '../../service/graphqlService';
import { useSnackbar } from '../../providers/SnackbarContext';
import useConfig from '../../hooks/useGetConfig';
import NotificationCenter from './NotificationsCenter';

export default function PortalConfig() {
  const { configData } = useConfig();

  const updateConfigMutation = useMutation((variables) => GraphqlService.updateConfig(variables.config));
  const openSnackBar = useSnackbar();

  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(true);
  const [notificationsOpen, setNotificationsOpen] = useState(true);

  useEffect(() => {
    if (configData && configData.maintenance !== undefined) {
      setMaintenanceMode(configData.maintenance === 'true');
    }
  }, [configData]);

  const handleSwitchChange = async (event) => {
    const newValue = event.target.checked;
    setMaintenanceMode(newValue);
    try {
      await updateConfigMutation.mutateAsync({
        config: JSON.stringify({
          maintenance: newValue.toString(),
        }),
      });
      openSnackBar('Config Updated', 'info');
    } catch (error) {
      openSnackBar(error.message, 'error');
      setMaintenanceMode(!newValue);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <PageBanner title="CONFIGURATION" />
      <div className="p-3 md:p-6">
        {/* Settings Accordion */}
        <div className="mb-4 bg-white rounded-lg shadow">
          <button
            type="button"
            className="flex items-center justify-between w-full p-4 font-semibold text-left text-gray-700 bg-white rounded-t-lg focus:outline-none hover:bg-gray-50"
            onClick={() => setSettingsOpen(!settingsOpen)}
          >
            <span>Settings</span>
            {settingsOpen ? (
              <ChevronUpIcon className="w-5 h-5 text-gray-500" />
            ) : (
              <ChevronDownIcon className="w-5 h-5 text-gray-500" />
            )}
          </button>
          {settingsOpen && (
            <div className="p-4 border-t border-gray-200">
              <div className="overflow-x-auto rounded-lg shadow-sm">
                <table className="min-w-full bg-white">
                  <tbody>
                    <tr className="border-b hover:bg-gray-50">
                      <td className="px-6 py-4 text-sm font-medium text-gray-900 text-center">
                        Maintenance Mode
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500 text-center">
                        <label htmlFor="maintenanceMode" className="flex items-center cursor-pointer justify-center">
                          <div className="relative">
                            <input
                              type="checkbox"
                              id="maintenanceMode"
                              className="sr-only"
                              checked={maintenanceMode}
                              onChange={handleSwitchChange}
                            />
                            <div className={`block w-10 h-6 rounded-full ${maintenanceMode ? 'bg-blue-600' : 'bg-gray-300'}`} />
                            <div className={`dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform ${maintenanceMode ? 'transform translate-x-full' : ''}`} />
                          </div>
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>

        {/* Notification Center Accordion */}
        <div className="bg-white rounded-lg shadow">
          <button
            type="button"
            className="flex items-center justify-between w-full p-4 font-semibold text-left text-gray-700 bg-white rounded-t-lg focus:outline-none hover:bg-gray-50"
            onClick={() => setNotificationsOpen(!notificationsOpen)}
          >
            <span>Notification Center</span>
            {notificationsOpen ? (
              <ChevronUpIcon className="w-5 h-5 text-gray-500" />
            ) : (
              <ChevronDownIcon className="w-5 h-5 text-gray-500" />
            )}
          </button>
          {notificationsOpen && (
            <div className="p-4 bg-white border-t border-gray-200 rounded-b-lg">
              <NotificationCenter />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
